export function friendlySaveError(error: unknown): string {
	const message = error instanceof Error ? error.message : 'Unable to save this answer right now.';
	if (message.includes('During testing enter email address client@example.invalid')) {
		return 'Email not saved. During testing enter email address client@example.invalid.';
	}
	if (message.includes('During testing enter phone number 718-555-0110')) {
		return 'Phone number not saved. During testing enter phone number 718-555-0110.';
	}
	if (message.includes('must be a valid email address')) {
		return 'Email not saved. Enter a complete email address in the format name@example.com.';
	}
	return `Your change was not saved. Please review the answer and try again. ${message}`;
}
